/**
 * Environment-aware configuration
 * All configuration comes from environment variables only
 */

const config = {
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || window.location.origin,
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL,
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY,
  ONESIGNAL_APP_ID: process.env.REACT_APP_ONESIGNAL_APP_ID,
};

// Validate required configuration
if (!config.SUPABASE_URL) {
  throw new Error('REACT_APP_SUPABASE_URL environment variable is required');
}

if (!config.SUPABASE_ANON_KEY) {
  throw new Error('REACT_APP_SUPABASE_ANON_KEY environment variable is required');
}

// Log configuration in development (without exposing secrets)
if (process.env.NODE_ENV === 'development') {
  console.log('[Config] Backend URL:', config.BACKEND_URL);
  console.log('[Config] Supabase URL:', config.SUPABASE_URL);
  console.log('[Config] Environment:', window.location.hostname);
}

/**
 * Fix image URLs to use the current backend URL
 * Handles images that were uploaded with hardcoded production URLs
 */
export const fixImageUrl = (imageUrl) => {
  if (!imageUrl) return imageUrl;
  
  // If the image URL contains /api/uploads/, ensure it uses the current backend URL
  if (imageUrl.includes('/api/uploads/')) {
    // Extract just the filename
    const filename = imageUrl.split('/api/uploads/').pop();
    // Return the corrected URL using current backend
    return `${config.BACKEND_URL}/api/uploads/${filename}`;
  }
  
  // If it's already a relative URL or external URL (Supabase, etc.), return as-is
  return imageUrl;
};

export default config;
